import { CharacterTypes, CharacterCategoryTypes } from 'constants/characters';

export function resizeCanvas(canvasEl, containerEl) {
  const { height, width } = containerEl.getBoundingClientRect();

  canvasEl.setAttribute('height', height);
  canvasEl.setAttribute('width', width);
}

export function getScaleDegree(characterType, characterCategoryType, scaleAlteration = 1) {
  let scaleDegree = 1;

  if (characterCategoryType === CharacterCategoryTypes.PRINT) {
    if (characterType === CharacterTypes.LOWERCASE) {
      scaleDegree = 0.75;
    }
  }

  if (characterCategoryType === CharacterCategoryTypes.CURSIVE) {
    if (characterType === CharacterTypes.CONNECTIONS) {
      scaleDegree = 0.5;
    }

    if (characterType === CharacterTypes.LOWERCASE) {
      scaleDegree = 0.75;
    }
  }

  return scaleDegree * scaleAlteration;
}
